import { Fancybox } from "@fancyapps/ui";

import "@fancyapps/ui/dist/fancybox.css";
import './fancybox.scss';

Fancybox.defaults.on = {
	'Carousel.createSlide': (fancybox, carousel, slide, c) => {
		let rez;

		if (rez = slide.src.match(
			/(?:https?:\/\/)?(?:www\.)?rutube\.ru\/video\/([^\/?]*)\/?.*/i
		)) {
			slide.type = 'video';
			slide.src = 'https://rutube.ru/play/embed/' + rez[1];
		}
		else if (rez = slide.src.match(
			/(?:https?:\/\/)?(?:www\.)?vk\.com\/video_ext\.php.*/i
		)) {
			slide.type = 'video';
		}
	},
};

export { Fancybox };